import { render, staticRenderFns } from "./subject_diagnosis.vue?vue&type=template&id=b972bc10&scoped=true"
import script from "./subject_diagnosis.vue?vue&type=script&lang=js"
export * from "./subject_diagnosis.vue?vue&type=script&lang=js"
import style0 from "./subject_diagnosis.vue?vue&type=style&index=0&id=b972bc10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b972bc10",
  null
  
)

export default component.exports